/**
 * The colours handed to a sketch.
 *
 * Reuses the plot palette rather than defining a second one: a bouncing ball
 * and the graph of its height belong to the same answer and must not disagree
 * about what "the first series" looks like.
 */

import type { AnimTheme } from "../../shared/anim-protocol.ts";
import { CHROME, MAX_SERIES_COLORS, seriesColor, type ThemeMode } from "../plot/palette.ts";

export function animTheme(mode: ThemeMode): AnimTheme {
  const chrome = CHROME[mode];

  return {
    mode,
    surface: chrome.surface,
    ink: chrome.ink,
    muted: chrome.muted,
    grid: chrome.grid,
    axis: chrome.axis,
    series: Array.from({ length: MAX_SERIES_COLORS }, (_, index) =>
      seriesColor(index, mode),
    ),
  };
}
